import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["specificFields", "recurringFields", "timeSlotsFields", "timeSlotsContainer", "timeSlotRow", "dateField", "wdayField"]

  toggleType(event) {
    const isSpecific = event.target.value === "specific"
    
    if (isSpecific) {
      this.specificFieldsTarget.classList.remove("hidden")
      this.recurringFieldsTarget.classList.add("hidden")
      // Vider le champ wday pour éviter la validation "pas les deux"
      if (this.hasWdayFieldTarget) {
        this.wdayFieldTarget.value = ""
      }
    } else {
      this.specificFieldsTarget.classList.add("hidden")
      this.recurringFieldsTarget.classList.remove("hidden")
      // Vider le champ date pour éviter la validation "pas les deux"
      if (this.hasDateFieldTarget) {
        this.dateFieldTarget.value = ""
      }
    }
  }

  toggleClosed(event) {
    if (event.target.checked) {
      this.timeSlotsFieldsTarget.classList.add("hidden")
    } else {
      this.timeSlotsFieldsTarget.classList.remove("hidden")
    }
  }

  addTimeSlot() {
    const template = `
      <div class="flex items-center gap-3" data-business-hours-override-form-target="timeSlotRow">
        <div class="flex items-center gap-2">
          <input type="time" name="business_hours_override[time_slots][][start_time]" value="09:00" class="block rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-sz-primary-600 sm:text-sm sm:leading-6">
          <span class="text-gray-500">à</span>
          <input type="time" name="business_hours_override[time_slots][][end_time]" value="18:00" class="block rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-sz-primary-600 sm:text-sm sm:leading-6">
        </div>
        <button type="button" data-action="click->business-hours-override-form#removeTimeSlot" class="text-red-500 hover:text-red-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>
        </button>
      </div>
    `
    this.timeSlotsContainerTarget.insertAdjacentHTML("beforeend", template)
  }

  removeTimeSlot(event) {
    const row = event.target.closest("[data-business-hours-override-form-target='timeSlotRow']")
    if (row) {
      row.remove()
    }
  }
}
